import {NgClass, NgIf} from '@angular/common';import {SmsirButtonHttpLoadingDirective} from '@shared/directives/smsir-button-http-loading.directive';

import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ButtonComponent, MODAL_DATA, ModalRef} from '@sms-ir/ui-components';

export interface VerificationModalData {
  isPending?: boolean;
}

@Component({
  selector: 'app-verification-modal',
  standalone: true,
  imports: [NgIf, NgClass, ButtonComponent,
    SmsirButtonHttpLoadingDirective,
  ],
  templateUrl: './verification-modal.component.html',
  styleUrls: ['./verification-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerificationModalComponent {
  private readonly modalRef = inject<ModalRef<boolean>>(ModalRef);
  private readonly data = inject<VerificationModalData>(MODAL_DATA);

  readonly isPending = this.data.isPending ?? false;

  onSubmit(): void {
    this.modalRef.close(true);
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}
